import { NavigableModal } from '$components'
import { useNavigate } from 'react-router-dom'
import { InviteMemberForm } from '$features/team/forms/invite-member'

export function InviteMemberModal() {
  const navigate = useNavigate()

  const handleClose = () => navigate(-1)

  return (
    <NavigableModal onClose={handleClose}>
      <NavigableModal.Header>
        <NavigableModal.Heading>
          Invite Team Member
        </NavigableModal.Heading>
      </NavigableModal.Header>

      <NavigableModal.Content>
        <InviteMemberForm />
      </NavigableModal.Content>
    </NavigableModal>
  )
}
